import QueueAnim from 'rc-queue-anim';
import React from 'react';
import { PageLoading } from 'components/atoms/loading';
import { SingleValue } from 'components/atoms/select';
import {
  BySalesforceResourceMap,
  PartialSalesforceFieldMappingLocalData,
  SalesforceFieldMappingLocalData,
} from '../../types';
import { FieldsObject } from '../fields-object';
import { EmptyState } from './empty-state';
import { ResourceHeader } from './header';

export type ResourceMappingList = {
  integrationId: number;
  resources: BySalesforceResourceMap;
  resourceMappingsStatus: 'idle' | 'error' | 'loading' | 'success';
  onObjectRemove: (resourceId: number) => void;
  onMappingAdd: (resourceId: number, externalField: SingleValue) => void;
  onMappingRemove: (
    resourceId: number,
    fieldMapping: SalesforceFieldMappingLocalData,
  ) => void;
  onMappingChange: (
    resourceId: number,
    mappingId: string,
    payload: PartialSalesforceFieldMappingLocalData,
  ) => void;
  showResourceModal: (value: boolean) => void;
};

export const ResourceMappingList = ({
  integrationId,
  resourceMappingsStatus,
  resources,
  showResourceModal,
  onObjectRemove,
  onMappingAdd,
  onMappingRemove,
  onMappingChange,
}: ResourceMappingList) => {
  switch (resourceMappingsStatus) {
    case 'loading': {
      return <PageLoading />;
    }

    case 'success': {
      const resourceList = Object.values(resources);

      if (resourceList?.length > 0) {
        return (
          <>
            <ResourceHeader />
            <QueueAnim component="div" type={['right', 'left']} leaveReverse>
              {resourceMappingsStatus === 'success' &&
                Object.values(resources).map((fieldObject) => (
                  <FieldsObject
                    key={fieldObject.id}
                    onMappingAdd={onMappingAdd}
                    onMappingRemove={onMappingRemove}
                    onMappingChange={onMappingChange}
                    onObjectRemove={onObjectRemove}
                    fieldObject={fieldObject}
                    integrationId={Number(integrationId)}
                  />
                ))}
            </QueueAnim>
          </>
        );
      }

      return <EmptyState onResourceAdd={showResourceModal} />;
    }

    case 'idle':
    case 'error':
    default: {
      return <></>;
    }
  }
};
